import { defineMessages } from 'react-intl';

export const scope = 'app.containers.InfoPage';

export default defineMessages({
  s1: {
    title: {
      id: `${scope}.s1.title`,
      defaultMessage: `What is FINIX token?`,
    },
    detail: {
      id: `${scope}.s1.detail`,
      defaultMessage: `FINIX is a ecosystem token within the Definix platform. FINIX can only be earned by staking cryptocurrency supported on the platform. Here are the utility of FINIX:`,
    },
  },
  s2: {
    investment: {
      id: `${scope}.s2.investment`,
      defaultMessage: `Investment Privilege`,
    },
    investment2: {
      id: `${scope}.s2.investment2`,
      defaultMessage: `FINIX token provides extra privilege for token holders, which include financial products on Definix. Especially, Definix’s investment products.`,
    },
    governance: {
      id: `${scope}.s2.governance`,
      defaultMessage: `Ecosystem Token`,
    },
    governance2: {
      id: `${scope}.s2.governance2`,
      defaultMessage: `FINIX is a token that developers create to allow token holders to help shape the future of a protocol. Ecosystem token holders can influence decisions concerning the project such as proposing or deciding on new feature proposals and even changing the governance system itself.`,
    },
    finix: {
      id: `${scope}.s2.finix`,
      defaultMessage: `FINIX Challenge`,
    },
    finix2: {
      id: `${scope}.s2.finix2`,
      defaultMessage: `FINIX token is used as a resource in FINIX challenge. For the trader who wants to be Fund Manager on Definix, they are mandatory to participate in this challenge. The only qualified traders will earn the right to create and manage their own fund.`,
    },
  },
});
